import React from 'react';
import Icon from '@ant-design/icons';
import { Dropdown, Menu, Row, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { BellIcon } from '../../../../components/ui/icons';
import { StyledMenuNotificacoes } from '../../styles';
import { notificationHandler } from '../../../../shared/util/NotificacoesHandler';
import { ReactComponent as Bell } from '../../../../images/svgs/bell.svg';
import { ReactComponent as Loading } from '../../../../images/svgs/loading.svg';
import styles from './NotificationsMenu.module.css';

const { Text } = Typography;

export default function NotificationsMenu(props) {
  const { t } = useTranslation('header');
  const {
    notifications,
    hasNotifications,
    qtdNotificacoes,
    seeAll,
    setSeeAll,
    getNotificationsAll,
    notificacoesLoading,
    marcarNotificacaoComoLida,
    links
  } = props;

  const handledNotifications = () => {
    if (notifications) {
      return notifications.map(item => notificationHandler(item, links));
    }
    return [];
  };

  const handleMenuClick = (e, item) => {
    if (e.key === 'ver-todas') {
      setSeeAll(true);
      getNotificationsAll();
    } else {
      marcarNotificacaoComoLida(item);
    }
  };

  const menu = (
    <StyledMenuNotificacoes>
      <Menu.Item className='menu-item__custom'>
        <div className='container-notificacoes'>
          {handledNotifications().map((item, index) => (
            <div
              style={{ fontWeight: '600 !important', minHeight: '50px' }}
              key={index}
              onClick={e => handleMenuClick(e, item)}
              className='dropdown-menu-item'>
              <Row
                justify='space-around'
                className='ant-row-flex flex-column'
                style={{ padding: '5px auto', fontWeight: '600 !important' }}>
                <div className='d-flex align-items-center'>
                  <Button
                    shape='circle'
                    icon={item.icon ? <item.icon /> : <Icon component={Bell} />}
                    style={{
                      color: '#b0b0b0',
                      marginRight: '5px',
                      width: '34px',
                      height: '34px'
                    }}
                  />
                  <span
                    className='m-auto'
                    style={{
                      fontSize: '11px',
                      letterSpacing: '0.7px',
                      color: '#2c2c2c',
                      whiteSpace: 'break-spaces'
                    }}>
                    {`${item.text}`}
                    {item.dateText && (
                      <span className='date-text ml-3'>{`${item.dateText}`}</span>
                    )}
                  </span>
                </div>
              </Row>
            </div>
          ))}
        </div>
      </Menu.Item>

      {handledNotifications().length === 0 && (
        <Menu.Item>{t('NO_NEW_NOTIFICATIONS')}</Menu.Item>
      )}

      {qtdNotificacoes > 5 && !seeAll ? <Menu.Divider /> : null}
      {qtdNotificacoes > 5 && !seeAll ? (
        <Menu.Item key='ver-todas' onClick={e => handleMenuClick(e)}>
          <Text type='primary'>{t('VIEW_ALL')}</Text>
        </Menu.Item>
      ) : null}
      {notificacoesLoading && (
        <Menu.Item>
          <Icon
            component={Loading}
            style={{ fontSize: 24, color: 'var(--text-color)' }}
            className='icon-loading'
          />
        </Menu.Item>
      )}
    </StyledMenuNotificacoes>
  );

  return (
    <Dropdown
      dropdownRender={() => menu}
      trigger={['click']}
      overlayStyle={{ position: 'fixed' }}
      placement='bottomRight'
      align={{ offset: [7, 0] }}>
      <div
        className={styles.trigger}
        role='button'
        aria-label={t('NOTIFICATIONS')}>
        {hasNotifications && <div className={styles.bubble} />}
        <BellIcon size={18} style={{ color: 'var(--ui-blue-link)' }} />
      </div>
    </Dropdown>
  );
}
